import { useEffect, useState } from "react";

/** Пока чанк едет быстрее этого — заставка молчит: за nginx в кабинете он
 *  приезжает за десятки миллисекунд, и многоточие на один кадр читалось бы как
 *  дрожание. */
const ЗАДЕРЖКА_МС = 300;

/**
 * Заставка ожидания ленивого экрана (волна F спеки 2026-10-12-code-audit-refactor).
 *
 * Экраны кабинета приезжают своими чанками по первому переходу, и на это время
 * `Suspense` в `App.tsx` рисует её вместо экрана. Тот же `<main>`, что у самих
 * экранов, — каркас (меню, шапка, сетка) не шелохнётся, а место экрана не
 * схлопнется; многоточие и цвет — те же, что у каркаса, пока он ждёт личность.
 */
export function ScreenFallback() {
  const [поздно, setПоздно] = useState(false);
  useEffect(() => {
    const t = window.setTimeout(() => setПоздно(true), ЗАДЕРЖКА_МС);
    return () => window.clearTimeout(t);
  }, []);
  return (
    <main
      aria-busy="true"
      className="flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto p-4 text-[12.5px] text-fg-muted"
    >
      {поздно ? "…" : null}
    </main>
  );
}
